import * as React from "react";

import { cn } from "@/lib/utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[112px] w-full appearance-none rounded-[1.5rem] border-none bg-slate-100/50 px-5 py-4 text-base text-[var(--athr-text-primary)] shadow-none placeholder:text-slate-400 transition-all duration-300 ease-spring-3",
        "focus:bg-white focus:ring-4 focus:ring-[rgba(0,74,198,0.08)] focus:shadow-sm",
        "focus-visible:bg-white focus-visible:ring-4 focus-visible:ring-[rgba(0,74,198,0.08)] focus-visible:shadow-sm",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
